import { current_account, emoji_param, globe_param } from '../../utils/DictionaryManagementUtils';
import { getFlowCode } from './GeneralUtills';

const IosKeyMap = {
  name: ['wls_menu_option_'],
  select_paying_account: ['selectTransferAccountNavigationTitle_'],
  transfer_to_not_on_list: ['selectRecipientPlusButtonTitle_'],
  select_contact_title: ['selectRecipientNavigationTitle_'],
  search_contact: ['selectRecipientTopViewTitle_'],
  search_contact_hint: ['selectRecipientSearchTextFieldPlaceholder_'],
  no_results: ['contactsListNoResultsHeader_',
    'banksListNoResultsHeader_',
    'branchesListNoResultsHeader_'],
  cancel: ['selectRecipientCancelButtonTitle_'],
  select_recipient_details_type: ['selectPaymentMethodNavigationTitle_'],
  translate_to: ['selectContactTransferToButtonTitle_'],
  credit_card_manual_name: ['creditCardFlowName_', 'creditCardInputHint_'],
  phone_number_manual_name: ['phoneNumberFlowName_', 'phoneNumberInputHint_'],
  bank_account_manual_name: ['accountNumberFlowName_', 'accountNumberAccountInputHint_'],
  iban_manual_name: ['ibanFlowName_', 'ibanInputHint_'],
  customer_id_manual_name: ['customerIdFlowName_', 'customerIdInputHint_'],
  cpf_cnpj_manual_name: ['cpfCnpjInputActionPathName_', 'cpfCnpjInputHint_'],
  email_manual_name: ['emailInputActionPathName_', 'emailInputHint_'],
  evp_manual_name: ['evpInputActionPathName_', 'evpInputHint_'],

  credit_card_enter_details: ['creditCardNavigationTitle_', 'transferCreditCardNavigationTitle_'],
  phone_number_enter_details: ['phoneNumberInputNavigationTitle_', 'transferPhoneNumberNavigationTitle_'],
  bank_account_enter_details: ['accountNumberInputNavigationTitle_', 'transferAccountNumberNavigationTitle_'],
  iban_enter_details: ['ibanInputNavigationTitle_', 'transferIbanNavigationTitle_'],
  customer_id_enter_details: ['customerIDInputNavigationTitle_', 'transferCustomerIDNavigationTitle_'],
  cpf_cnpj_enter_details: ['cpfInputNavigationTitle_', 'transferCpfNavigationTitle_'],
  email_enter_details: ['emailInputNavigationTitle_', 'transferEmailNavigationTitle_'],
  evp_enter_details: ['evpInputNavigationTitle_', 'transferEvpNavigationTitle_'],

  // todo
  // credit_card_recipient_name: ['accountNumberRecepientInputHint_'],
  // phone_number_recipient_name: ['accountNumberRecepientInputHint_'],
  // iban_recipient_name: ['accountNumberRecepientInputHint_'],
  // customer_id_recipient_name: ['accountNumberRecepientInputHint_'],
  // bank_account_recipient_name: ['accountNumberRecepientInputHint_'],
  // email_enter_recipient_name: ['accountNumberRecepientInputHint_'],
  // evp_enter_recipient_name: ['accountNumberRecepientInputHint_'],
  // cpf_cnpj_recipient_name: ['accountNumberRecepientInputHint_'],
  transaction_details: ['accountTransactionDetailsNavigationTitle_'],
  confirm_action: ['confirmAccountTransactionActionNavigationTitle_'],
  go_account_balance: ['transferSuccessBackToMenuButtonTitle_'],
  balance: ['balanceString'],
  recipient_information: ['recipientValidationSectionTitle_'],
  save_to_contacts: ['saveToContactsToggleName_', 'saveToContactNameInputHint_'],
  next: ['nextButtonTitle_'],
  no_transactions_result: ['transactionsListNoResultsHeader_'],
  select_a_photo: ['selectReferenceImageNavigationTitle_'],
  bank_account_recipient_id: ['accountNumberIdInputHint_'],
  bank_account_recipient_name: ['accountNumberRecepientInputHint_'],
  bank_account_bank: ['accountNumberBankInputHint_'],
  bank_account_search_bank: ['accountNumberBanksSearchTextFieldPlaceholder_'],
  bank_account_branch_name: ['accountNumberBranchInputHint_'],
  bank_account_search_branch: ['accountNumberBranchesSearchTextFieldPlaceholder_'],
  bank_account_save_to_contacts: ['saveToContactsToggleName_'],
  how_much_to_transfer: ['amountInputNavigationTitle_'],
  equivalent_to: ['amountInputEquivalentPrefixText_'],
  available_balance: ['wls_available_balance_label_'],
  payment_reason: ['selectReferenceNavigationTitle_'],
  add_a_reference: ['referenceMainNavigationTitle_', 'referenceInputNavigationTitle_'],
  select_payment_reason: ['referenceMainSelectReasonButtonTitle_'],
  custom: ['selectReferenceCustomReasonName_'],
  enter_free_text: ['referenceInputHint_'],
  your_receipt: ['transferReceiptNavigationTitle_'],
  share_in_chat: ['transferSuccessShareInChatButtonTitle_'],
  share_receipt: ['transferSuccessShareReceiptButtonTitle_'],
  more_details: ['transferSuccessMoreButtonTitle_'],
  make_another_transfer: ['transferSuccessMakeAnotherButtonTitle_'],
  does_it_look_ok: ['transferConfirmationNavigationTitle_'],
  transaction_fee_is_on_the_recipient: ['confirmationCheckboxTitle_'],
  confirm: ['confirmTransferButtonTitle_'],
  share: ['transferReceiptShareButtonTitle_'],
  copied_now_paste_to_chat: ['transferReceiptCopiedPopupTitle_'],
  go_back_to_menu: ['transferSuccessBackToMenuButtonTitle_'],
  done: ['transferSuccessBackToMenuButtonTitle_'],
  change_paying_account: ['changePayingAccount'],
  select_currency: ['SelectCurrency'],
  account_balance: ['selectTransferAccountNavigationTitle_'],
  your_bills: ['selectBillNavigationTitle_'],
  pay_now: ['selectBillCellPayNowButton_'],
  insert_another_bill: ['payBillsInsertAnotherButtonTitle_'],
  type_the_barcode_title: ['payBillBarcodeInputNavigationTitle_'],
  confirm_payment: ['payBillConfirmPaymentButtonTitle_'],
  close: ['transferSuccessCloseButtonTitle_', 'payBillConfirmationCloseButtonTitle_'],
  total_payment: ['totalPaymentLabel_'],
  participants: ['participantsLabel_'],
  participant: ['participantLabel_'],
  transaction_success_default_output: ['transactionSuccessDefaultOutputText_'],
  enter_amount_str: ['enter_amount_str'],
  add_contact_name: ['add_contact_name_'],
  pay_another_bill: ['pay_another_bill'],
  amount_participant_title: ['amount_participant_title_'],
  enter_total_amount: ['enter_total_amount'],
  current_account: ['menuCurrentAccountTitle'],

  l_k_title: ['introScreenTitle'],
  l_k_message: ['introScreenMessage'],
  l_k_cancel: ['introScreenCancelButtonTitle'],
  got_it: ['introScreenGotItButtonTitle'],
  face_id_to_approve: ['faceIdNavigationTitle'],
  touch_id_to_approve: ['touchIdNavigationTitle'],
  enter_your_pin_code: ['pinCodeNavigationTitle'],
  enter_the_code_you_just_received: ['otpCodeNavigationTitle'],
  enter_credentials: ['authCredentialsNavigationTitle'],
  username: ['authCredentialsIdFreeInputHint'],
  password: ['authCredentialsPasswordInputHint'],
  approve: ['authApproveButtonTitle'],
  change_id: ['authCredentialsChangeIdButton'],
  auth_password_error: ['auth_password_error'],
  auth_pin_code_error: ['auth_pin_code_error'],
  auth_wrong_code_error: ['auth_wrong_code_error'],

  error_message_general_error: ['error_message_general_error'],
  error_message_no_connection: ['error_message_no_connection'],
  error_message_transaction_failed: ['error_message_transaction_failed'],
  error_message_permission_to_photos: ['noGalleryPermissionsTitle_'],
  error_message_landscape_not_supported: ['landscapeBlockerScreenTitle'],
  try_again: ['errorTryAgainButtonTitle'],
  reload: ['errorReloadButtonTitle'],
  take_me_to_settings: ['openSettingsTitle_'],

  nothing_to_see_here: ['commonEmptyListPlaceholder'],

  imsg_expand_title: ['iMessageCompactModeBlockerScreenTitle'],
  imsg_expand_button: ['iMessageCompactModeBlockerScreenButtonTitle'],

  privacy_policy_link: ['privacy_policy_link'],
  o_a_title: ['onboardingIntroTitle'],
  o_a_button_title: ['getBankKeyboardButton'],
  o_a_privacy_policy: ['termsAndPrivacyButton'],
  maybe_later: ['maybeLaterButton'],

  promo_text_1: ['onboardingTypingExperienceTitle'],
  promo_text_2: ['onboardingMainServicesTitle'],
  promo_text_3: ['onboardingMediaTitle'],
  promo_text_4: ['onboardingSecurityTitle'],

  o_i_step_1_of_2: ['o_i_step_1_of_2'],
  o_i_enable_bank_keyboard: ['enableKeyboardTitle'],
  o_i_enable_bank_keyboard_and: ['o_i_enable_bank_keyboard_and'],
  o_i_goto_settings: ['goToSettingsLabel'],
  o_i_tap_keyboards: ['tapKeyboardsLabel'],
  o_i_enable_keyboard: ['enableKeyboardAndFullAccessLabel'],
  o_i_come_back_here: ['comebackLabel'],
  o_i_your_privacy_title: ['privacyHintTitle'],
  o_i_your_privacy: ['privacyHintSubtitle'],
  o_i_take_me_there: ['takeMeThereButton'],
  o_i_nanother_time: ['doItAnotherTimeButton'],
  o_i_step_2_of_2: ['stepTitleLabel'],
  o_i_switch_to_bank_keyboard: ['selectKeyboardTitle'],
  o_i_switch_to_bank_keyboard_and: ['o_i_switch_to_bank_keyboard_and'],
  o_i_lets_do_it: ['go_activation_select_ime_next_button_label'],
  o_i_touch_and_hold: ['selectKeyboardSubtitle'],
  success: ['successTitle'],
  o_done: ['doneButton'],
  o_i_give_it_a_go: ['successHintTitle'],
  o_i_tap_the_bank_icon: ['successHintSubtitle'],
  bank_keyboard: ['bank_keyboard'],
  keyboard_button: ['keyboard_button'],
  onboarding_titleBar: ['onboarding_titleBar'],
  another_keyboard: ['another_keyboard'],
  select_keyboard: ['select_keyboard'],
  other_keyboards: ['other_keyboards'],
  select_loan_source: ['selectTransferAccountNavigationTitle'],
  enter_loan_amount: ['amountInputNavigationTitle_'],
  confirm_loan_details: ['transferConfirmationNavigationTitle'],
  confirm_loan: ['confirmationPaidByTitle'],
  select_loan_option: ['selectPackageNavigationTitle'],
  enter_number_installments: ['loanInstallmentsInputNavigationTitle', 'loanInstallmentsInputHint'],
};

function getIosStringFormat(bank_name, configKey, value, flowCode = '') {
  let res = '';
  if (IosKeyMap[configKey]) {
    IosKeyMap[configKey].forEach((keyCategory) => {
      res += `            <key>${keyCategory}${flowCode}</key>\n`;
      res += `            <string>${decipheringString(bank_name, value)}</string>\n`;
    });
  }
  return res;
}

function getIosServiceStrings(bank_name, service, flowCode, configurations) {
  let res = '';
  res += getIosStringFormat(bank_name, 'name', service.name, flowCode);
  service.screens_ordering.forEach((stepKey) => {
    if (service[stepKey]) {
      Object.keys(service[stepKey])
        .forEach((subStepKey) => {
          const value = service[stepKey][subStepKey];
          if (subStepKey === 'manual_recipients') {
            service[stepKey].screens_ordering
              .filter((manual_recipient) => service[stepKey].manual_recipients[manual_recipient].selected)
              .forEach((manual_recipient) => {
                const manualRecipient = service[stepKey].manual_recipients[manual_recipient];
                Object.keys(manualRecipient)
                  .forEach((subManualRecipientKey) => {
                    const manualRecipientValue = manualRecipient[subManualRecipientKey];
                    if (typeof manualRecipientValue === 'string') {
                      res += getIosStringFormat(bank_name, `${manual_recipient}_${subManualRecipientKey}`, manualRecipientValue, flowCode);
                    }
                  });
              });
          }
          if (typeof value === 'string') {
            if (subStepKey === 'go_back_to_menu') {
              if (configurations.services.menu.layout_menu_screen) {
                res += getIosStringFormat(bank_name, subStepKey, value, flowCode);
              }
            } else if (subStepKey === 'done') {
              if (!configurations.services.menu.layout_menu_screen) {
                res += getIosStringFormat(bank_name, subStepKey, value, flowCode);
              }
            } else {
              res += getIosStringFormat(bank_name, subStepKey, value, flowCode);
            }
          }
        });
    }
  });
  return res;
}

export const serviceCategoriesTexts = {
  send_money: extractTextForAndroidSendMoney,
  loan: extractTextForAndroidSendMoney,
  account_info: extractTextForAndroidAccountInfo,
  pay_bills: extractTextForAndroidPayBills,
  request_payment: extractTextForAndroidSendMoney,
  split_payment: extractTextForAndroidSendMoney,
  top_up: extractTextForAndroidSendMoney,
  link_out: extractTextForAndroidLinkOut,
};

export function extractTextForIOS_Onboarding(configurations) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="UTF-8"?>\n';
  res
    += '<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "https://www.apple.com/DTDs/PropertyList-1.0.dtd">\n';
  res += '<plist version="1.0">\n';
  res += '<dict>\n';
  res += '    <key>PKOnboardingLocalizations</key>\n';
  res += '    <dict>\n';
  res += '        <key>en</key>\n';
  res += '        <dict>\n';

  configurations.onboarding.screens_ordering.forEach((onboardingKey) => {
    Object.keys(configurations.onboarding[onboardingKey])
      .forEach((subOnboardingKey) => {
        const value = configurations.onboarding[onboardingKey][subOnboardingKey];
        if (typeof value === 'string') {
          res += getIosStringFormat(bank_name, subOnboardingKey, value);
        }
      });
  });

  res += '        </dict>\n';
  res += '    </dict>\n';
  res += '</dict>\n';
  res += '</plist>\n';
  return res;
}

export function extractTextForIOS(configurations) {
  let res = '<?xml version="1.0" encoding="UTF-8"?>\n';
  res
    += '<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "https://www.apple.com/DTDs/PropertyList-1.0.dtd">\n';
  res += '<plist version="1.0">\n';
  res += '<dict>\n';
  res += '    <key>PKPaymentLocalizations</key>\n';
  res += '    <dict>\n';
  res += '        <key>en</key>\n';
  res += '        <dict>\n';

  res += getIosStringFormat(configurations, current_account, configurations.services.menu.current_account);

  configurations.services.screens_ordering
    .filter((serviceKey) => configurations.services[serviceKey].selected)
    .forEach((serviceKey) => {
      const service = configurations.services[serviceKey];
      res += getIosServiceStrings(configurations.general.bank_name, service, getFlowCode(service), configurations);
    });

  configurations.launch.screens_ordering.forEach((launchKey) => {
    Object.keys(configurations.launch[launchKey])
      .forEach((subLaunchKey) => {
        const value = configurations.launch[launchKey][subLaunchKey];
        if (typeof value === 'string') {
          res += getIosStringFormat(configurations.general.bank_name, subLaunchKey, value);
        }
      });
  });

  res += '        </dict>\n';
  res += '    </dict>\n';
  res += '</dict>\n';
  res += '</plist>\n';
  return res;
}

const decipheringString = (bank_name, text) => {
  const xml_escape = require('xml-escape');
  if (!text) return '';
  text = text
    .replace('[bank]', bank_name)
    .replace('[Bank]', bank_name)
    .replace('[bank name]', bank_name)
    .replace('[Bank name]', bank_name)
    .replace('[Bank Name]', bank_name)
    .replace('[kbd]', bank_name)
    .replaceAll('[BR]', ' ')
    .replaceAll(globe_param, '%@')
    .replaceAll(emoji_param, '%@');

  return xml_escape(text.replace('\n', '\\n'));
};

export function extractDatePickerStyleForAndroid(configurations) {
  const { colors } = configurations.theme;

  let res = '<?xml version="1.0" encoding="UTF-8"?>\n';
  res += '<resources>\n';

  res
    += '    <style name="DatePickerStyle" parent="Theme.AppCompat.Light.Dialog">\n';

  res += `        <item name="colorAccent">${colors.primary_cta_color}</item>\n`;
  res += `        <item name="android:textColorPrimary">${colors.primary_font_color}</item>\n`;
  res += `        <item name="android:textColorSecondary">${colors.secondary_font_color}</item>\n`;
  res += `        <item name="android:textColorPrimaryInverse">${colors.cta_font_color}</item>\n`;
  res += `        <item name="android:textColorSecondaryInverse">${colors.cta_font_color}</item>\n`;

  res += '    </style>\n';

  res += '</resources>\n';
  return res;
}

export function extractTextForAndroidSendMoney(
  configurations,
  service,
  flowCode,
) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="utf-8"?>\n';
  res += '<resources>\n';

  res += '    <!--  Menu  -->\n';
  res += `    <string name="wls_menu_option_${flowCode}">${decipheringString(bank_name, service.name)}</string>\n`;
  res += '\n';

  if (service.amount) {
    res += '    <!--  Select transfer account  -->\n';
    res += `    <string name="wls_select_account_title_${flowCode}">${decipheringString(bank_name,
      service.amount.select_paying_account)}</string>\n`;
    res += '\n';
  }

  if (service.source) {
    res += '    <!--  Select transfer account  -->\n';
    res += `    <string name="wls_select_account_title_${flowCode}">${decipheringString(bank_name,
      service.source.select_loan_source)}</string>\n`;
    res += '\n';
  }

  if (service.number) {
    res += '    <!--  Installments number input  -->\n';
    res += `    <string name="wls_installments_number_input_title_${flowCode}">${decipheringString(bank_name,
      service.number.enter_number_installments)}</string>\n`;
    res += `    <string name="wls_installments_number_input_hint_${flowCode}">${decipheringString(bank_name,
      service.number.enter_number_installments)}</string>\n`;
    res += `    <string name="wls_next_label_${flowCode}">${decipheringString(bank_name,
      service.number.next)}</string>\n`;
    res += '\n';
  }

  if (service.option) {
    res += '    <!--  Select package  -->\n';
    res += `    <string name="wls_select_package_title_${flowCode}">${decipheringString(bank_name,
      service.option.select_loan_option)}</string>\n`;
    res += '\n';
  }

  if (service.recipient) {
    res += '    <!--  Select transfer method  -->\n';
    res += `    <string name="wls_select_transfer_method_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.select_recipient_details_type)}</string>\n`;
    res += '\n';
    res += `    <string name="wls_credit_card_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.credit_card.manual_name)}</string>\n`;
    res += `    <string name="wls_phone_number_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.phone_number.manual_name)}</string>\n`;
    res += `    <string name="wls_account_number_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.bank_account.manual_name)}</string>\n`;
    res += `    <string name="wls_iban_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.iban.manual_name)}</string>\n`;
    res += `    <string name="wls_customer_id_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.customer_id.manual_name)}</string>\n`;
    res += `    <string name="wls_email_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.email.manual_name)}</string>\n`;
    res += `    <string name="wls_evp_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.evp.manual_name)}</string>\n`;
    res += `    <string name="wls_cpf_cnpj_label_${flowCode}">${decipheringString(bank_name, service.recipient.manual_recipients.cpf_cnpj.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  Select Contact  -->\n';
    res += `    <string name="wls_select_contact_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.select_contact_title)}</string>\n`;
    res += `    <string name="wls_contact_list_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.search_contact)}</string>\n`;
    res += `    <string name="wls_search_contact_hint_${flowCode}">${decipheringString(bank_name,
      service.recipient.search_contact_hint)}</string>\n`;
    res += `    <string name="wls_search_recipient_no_results_label_${flowCode}">${decipheringString(bank_name,
      service.recipient.no_results)}</string>\n`;
    res += `    <string name="wls_select_custom_contact_${flowCode}">${decipheringString(bank_name,
      service.recipient.transfer_to_not_on_list)}</string>\n`;
    if (service.recipient.is_multiple_recipient) {
      res += '\n';
      res += '    <!-- Amount per Participant -->\n';
      res += `    <string name="wls_amount_per_participant_title_${flowCode}">${decipheringString(bank_name, service.recipient.amount_participant_title)}</string>\n`;
      res += `    <string name="wls_total_payment_label_${flowCode}">${decipheringString(bank_name, service.recipient.total_payment)}</string>\n`;
      res += `    <string name="wls_participants_label_${flowCode}">${decipheringString(bank_name, service.recipient.participants)}</string>\n`;
    }
    res += '\n';
    res += '    <!--  Recipients  -->\n';
    res += `    <string name="wls_recipient_info_title_${flowCode}">${decipheringString(bank_name, service.recipient.recipient_information)}</string>\n`;
    res += `    <string name="wls_next_label_${flowCode}">${decipheringString(bank_name, service.recipient.next)}</string>\n`;
    res += `    <string name="wls_recipient_save_to_contacts_label_${flowCode}">${decipheringString(bank_name, service.recipient.save_to_contacts)}</string>\n`;
    res += '\n';
    res += '    <!--  Phone number input  -->\n';
    res += `    <string name="wls_phone_number_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.phone_number.enter_details)
      .replace('&apos;', '\'')}</string>\n`;
    res += `    <string name="wls_phone_number_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.phone_number.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  IBAN input  -->\n';
    res += `    <string name="wls_iban_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.iban.enter_details)
      .replace('&apos;', '\'')}</string>\n`;
    res += `    <string name="wls_customer_id_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.customer_id.enter_details)
      .replace('&apos;', '\'')}</string>\n`;
    res += `    <string name="wls_iban_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.iban.manual_name)}</string>\n`;
    res += '\n';
    res += `    <string name="wls_iban_name_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.iban.recipient_name)}</string>\n`;
    res += '\n';
    res += '    <!--  Credit card input  -->\n';
    res += `    <string name="wls_credit_card_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.credit_card.enter_details)}</string>\n`;
    res += `    <string name="wls_credit_card_number_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.credit_card.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  Account number input  -->\n';
    res += `    <string name="wls_account_number_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.enter_details)}</string>\n`;
    res += `    <string name="wls_account_id_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.recipient_id)}</string>\n`;
    res += `    <string name="wls_account_name_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.recipient_name)}</string>\n`;
    res += `    <string name="wls_account_bank_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.bank)}</string>\n`;
    res += `    <string name="wls_account_branch_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.branch_name)}</string>\n`;
    res += `    <string name="wls_account_number_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  Email input  -->\n';
    res += `    <string name="wls_email_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.email.enter_details)
      .replace('&apos;', '\'')}</string>\n`;
    res += `    <string name="wls_email_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.email.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  EVP input  -->\n';
    res += `    <string name="wls_evp_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.evp.enter_details)
      .replace('&apos;', '\'')}</string>\n`;
    res += `    <string name="wls_evp_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.evp.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  CPF/CNPJ input  -->\n';
    res += `    <string name="wls_cpf_cnpj_input_title_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.cpf_cnpj.enter_details)
      .replace('&apos;', '\'')}</string>\n`;
    res += `    <string name="wls_cpf_cnpj_hint_${flowCode}">* ${decipheringString(bank_name,
      service.recipient.manual_recipients.cpf_cnpj.manual_name)}</string>\n`;
    res += '\n';
    res += '    <!--  Select account bank  -->\n';
    res += `    <string name="wls_search_account_bank_hint_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.search_bank)}</string>\n`;
    res += `    <string name="wls_search_account_bank_no_results_label_${flowCode}">${decipheringString(bank_name,
      service.recipient.no_results)}</string>\n`;
    res += '\n';
    res += '    <!--  Select account branch  -->\n';
    res += `    <string name="wls_search_account_branch_hint_${flowCode}">${decipheringString(bank_name,
      service.recipient.manual_recipients.bank_account.search_branch)}</string>\n`;
    res += `    <string name="wls_search_account_branch_no_results_label_${flowCode}">${decipheringString(bank_name,
      service.recipient.no_results)}</string>\n`;
    res += '\n';
  }
  if (service.amount) {
    res += '    <!--  Amount input  -->\n';
    res += `    <string name="wls_amount_input_title_${flowCode}">${decipheringString(bank_name,
      service.amount.how_much_to_transfer)}</string>\n`;
    if (flowCode === '180') {
      res += `    <string name="wls_amount_input_title_${flowCode}">${decipheringString(bank_name,
        service.amount.enter_loan_amount)}</string>\n`;
    }
    res += `    <string name="wls_available_balance_label_${flowCode}">${decipheringString(bank_name,
      service.amount.account_balance)}</string>\n`;
    res += `    <string name="wls_equivalent_to_label_${flowCode}">${decipheringString(bank_name,
      service.amount.equivalent_to)}</string>\n`;
    res += '\n';
  }
  if (service.reference) {
    res += '    <!--  Reference image  -->\n';
    res += `    <string name="wls_select_reference_image_title_${flowCode}">${decipheringString(bank_name,
      service.reference.select_a_photo)}</string>\n`;
    res += `    <string name="wls_access_photos_title_${flowCode}">${decipheringString(bank_name,
      configurations.launch.error_messages.error_message_permission_to_photos)}</string>\n`;
    res += `    <string name="wls_access_photos_button_${flowCode}">${decipheringString(bank_name,
      configurations.launch.error_messages.take_me_to_settings)}</string>\n`;

    res += '    <!--  Reference input  -->\n';
    res += `    <string name="wls_reference_input_title_${flowCode}">${decipheringString(bank_name,
      service.reference.add_a_reference)}</string>\n`;
    res += `    <string name="wls_reference_hint_${flowCode}">${decipheringString(bank_name,
      service.reference.enter_free_text)}</string>\n`;
    res += '\n';
    res += '    <!--  Reference main  -->\n';
    res += `    <string name="wls_reference_main_title_${flowCode}">${decipheringString(bank_name,
      service.reference.add_a_reference)}</string>\n`;
    if (service.reference.select_payment_reason) {
      res += `    <string name="wls_select_payment_reason_label_${flowCode}">${decipheringString(bank_name,
        service.reference.select_payment_reason)}</string>\n`;
    }
    res += `    <string name="wls_reference_input_title_${flowCode}">${decipheringString(bank_name,
      service.reference.add_a_reference)}</string>\n`;
    res += '\n';
    res += '    <!--  Select reference  -->\n';
    res += `    <string name="wls_select_reference_title_${flowCode}">${decipheringString(bank_name,
      service.reference.payment_reason)}</string>\n`;
    if (service.reference.custom) {
      res += `    <string name="wls_custom_reference_label_${flowCode}">${decipheringString(bank_name,
        service.reference.custom)}</string>\n`;
    }
  }

  res += '\n';
  const confirmation_config = service.confirmation || service.confirmation_split;
  res += '    <!--  Transfer Confirmation  -->\n';
  if (service.option) {
    res += `    <string name="wls_transfer_confirmation_title_${flowCode}">${decipheringString(bank_name,
      confirmation_config.confirm_loan_details)}</string>\n`;
    res += `    <string name="wls_confirm_transfer_label_${flowCode}">${decipheringString(bank_name,
      confirmation_config.confirm_loan)}</string>\n`;
  } else {
    res += `    <string name="wls_transfer_confirmation_title_${flowCode}">${decipheringString(bank_name,
      confirmation_config.does_it_look_ok)}</string>\n`;
  }
  res += `    <string name="wls_more_details_label_${flowCode}">${decipheringString(bank_name,
    confirmation_config.more_details)}</string>\n`;
  res += `    <string name="wls_close_label_${flowCode}">${decipheringString(bank_name,
    service.success.close)}</string>\n`;
  res += `    <string name="wls_confirm_transfer_label_${flowCode}">${decipheringString(bank_name,
    confirmation_config.confirm)}</string>\n`;
  res += `    <string name="wls_transfer_confirmation_sender_label_${flowCode}">${decipheringString(bank_name,
    confirmation_config.confirmation_sender_label)}</string>\n`;
  res += `    <string name="wls_transaction_fee_on_recipient_label_${flowCode}">${decipheringString(bank_name,
    confirmation_config.transaction_fee_is_on_the_recipient)}</string>\n`;
  res += '\n';
  res += '    <!--  Transfer Success  -->\n';
  res += `    <string name="wls_share_in_chat_label_${flowCode}">${decipheringString(bank_name,
    service.success.share_in_chat)}</string>\n`;
  res += `    <string name="wls_view_and_share_receipt_label_${flowCode}">${decipheringString(bank_name,
    service.success.share_receipt)}</string>\n`;
  res += `    <string name="wls_make_another_transfer_label_${flowCode}">${decipheringString(bank_name,
    service.success.make_another_transfer)}</string>\n`;
  if (configurations.services.menu.layout_menu_screen) {
    res += `    <string name="wls_go_back_to_menu_label_${flowCode}">${decipheringString(bank_name,
      service.success.go_back_to_menu)}</string>\n`;
  } else {
    res += `    <string name="wls_go_back_to_menu_label_${flowCode}">${decipheringString(bank_name,
      service.success.done)}</string>\n`;
  }
  res += `    <string name="wls_success_more_details_label_${flowCode}">${decipheringString(bank_name,
    service.success.more_details)}</string>\n`;
  res += `    <string name="wls_success_close_label_${flowCode}">${decipheringString(bank_name,
    service.success.close)}</string>\n`;
  res += '\n';
  res += '    <!--  Transfer Receipt  -->\n';
  res += `    <string name="wls_receipt_title_${flowCode}">${decipheringString(bank_name,
    service.success.your_receipt)}</string>\n`;
  res += `    <string name="wls_share_receipt_label_${flowCode}">${decipheringString(bank_name,
    service.success.share_receipt)}</string>\n`;
  res += '\n';
  res += '</resources>\n';
  return res;
}

export function extractTextForAndroidAccountInfo(
  configurations,
  service,
  flowCode,
) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="utf-8"?>\n';
  res += '<resources>\n';

  res += '    <!--  Menu  -->\n';
  res += `    <string name="wls_menu_option_${flowCode}">${decipheringString(bank_name, service.name)}</string>\n`;
  res += '\n';
  res += '    <!--  Select balance account  -->\n';
  res += `    <string name="wls_select_account_title_${flowCode}">${decipheringString(bank_name, service.balance.account_balance)}</string>\n`;
  res += '\n';
  res += '    <!--  Transaction Details  -->\n';
  res += `    <string name="wls_account_transaction_details_title_${flowCode}">${decipheringString(bank_name, service.transactions.transaction_details)}</string>\n`;
  res += '\n';
  res += '    <!--  Transaction Action Success  -->\n';
  res += `    <string name="wls_go_back_to_menu_label_${flowCode}">${decipheringString(bank_name, service.transactions.go_account_balance)}</string>\n`;
  res += '\n';
  res += `    <string name="wls_transfer_confirmation_title_${flowCode}">${decipheringString(bank_name, service.transactions.confirm_action)}</string>\n`;
  res += '\n';
  res += '</resources>\n';
  return res;
}

export function extractTextForAndroidPayBills(
  configurations,
  service,
  flowCode,
) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="utf-8"?>\n';
  res += '<resources>\n';

  res += '    <!--  Menu  -->\n';
  res += `    <string name="wls_menu_option_${flowCode}">${decipheringString(bank_name,
    service.name)}</string>\n`;
  res += '\n';
  res += '    <!--  Select bill  -->\n';
  res += `    <string name="wls_select_bill_title_${flowCode}">${decipheringString(bank_name, service.select_bill.your_bills)}</string>\n`;
  res += `    <string name="wls_select_bill_list_title_${flowCode}">${decipheringString(bank_name, configurations.launch.empty_state.your_bills)}</string>\n`;
  res += `    <string name="wls_pay_now_label_${flowCode}">${decipheringString(bank_name, service.select_bill.pay_now)}</string>\n`;
  res += `    <string name="wls_insert_another_bill_label_${flowCode}">${decipheringString(bank_name,
    service.select_bill.insert_another_bill)}</string>\n`;
  res += '\n';
  res += '    <!--  Barcode input  -->\n';
  res += `    <string name="wls_select_pay_bill_input_method_title_${flowCode}">${decipheringString(bank_name,
    service.select_bill.add_new_bill)}</string>\n`;
  res += `    <string name="wls_barcode_input_title_${flowCode}">${decipheringString(bank_name,
    service.select_bill.type_the_barcode_title)}</string>\n`;
  res += `    <string name="wls_select_pay_bill_input_method_scan_barcode_button_${flowCode}">${decipheringString(bank_name,
    service.select_bill.scan_barcode)}</string>\n`;
  res += `    <string name="wls_select_pay_bill_input_method_type_barcode_button_${flowCode}">${decipheringString(bank_name,
    service.select_bill.type_the_barcode)}</string>\n`;
  res += `    <string name="wls_barcode_scan_title_${flowCode}">${decipheringString(bank_name,
    service.select_bill.scan_bill_barcode)}</string>\n`;
  res += `    <string name="wls_barcode_scan_qr_error_title_${flowCode}">${decipheringString(bank_name,
    service.select_bill.invalid_qr)}</string>\n`;
  res += `    <string name="wls_barcode_scan_qr_error_button_try_again_${flowCode}">${decipheringString(bank_name,
    service.select_bill.try_again)}</string>\n`;
  res += '\n';
  res += '    <!--  Select bill account  -->\n';
  res += `    <string name="wls_select_account_title_${flowCode}">${decipheringString(bank_name,
    service.select_bill.select_paying_account)}</string>\n`;
  res += '\n';
  res += '    <!--  Bill Confirmation  -->\n';
  res += `    <string name="wls_bill_confirmation_title_${flowCode}">${decipheringString(bank_name,
    service.confirmation_bill.does_it_look_ok)}</string>\n`;
  res += `    <string name="wls_bill_date_label_${flowCode}">${decipheringString(bank_name,
    service.confirmation_bill.payment_date)}</string>\n`;
  res += `    <string name="wls_confirm_bill_label_${flowCode}">${decipheringString(bank_name,
    service.confirmation_bill.confirm_payment)}</string>\n`;
  res += `    <string name="wls_today_label_${flowCode}">${decipheringString(bank_name,
    service.confirmation_bill.today)}</string>\n`;
  res += `    <string name="wls_more_details_label_${flowCode}">${decipheringString(bank_name,
    service.confirmation_bill.more_details)}</string>\n`;
  res += `    <string name="wls_close_label_${flowCode}">${decipheringString(bank_name,
    service.confirmation_bill.close)}</string>\n`;
  res += '\n';
  res += '    <!--  Bill Success  -->\n';
  res += `    <string name="wls_share_in_chat_label_${flowCode}">${decipheringString(bank_name,
    service.success.share_in_chat)}</string>\n`;
  res += `    <string name="wls_view_and_share_receipt_label_${flowCode}">${decipheringString(bank_name,
    service.success.share_receipt)}</string>\n`;
  res += `    <string name="wls_go_back_to_menu_label_${flowCode}">${decipheringString(bank_name,
    service.success.go_back_to_menu)}</string>\n`;
  res += `    <string name="wls_success_more_details_label_${flowCode}">${decipheringString(bank_name,
    service.success.more_details)}</string>\n`;
  res += `    <string name="wls_success_close_label_${flowCode}">${decipheringString(bank_name,
    service.success.close)}</string>\n`;
  res += '\n';
  res += '    <!--  Bill Receipt  -->\n';
  res += `    <string name="wls_receipt_title_${flowCode}">${decipheringString(bank_name,
    service.success.your_receipt)}</string>\n`;
  res += `    <string name="wls_share_receipt_label_${flowCode}">${decipheringString(bank_name,
    service.success.share_receipt)}</string>\n`;
  res += '\n';
  res += '</resources>\n';
  return res;
}

export function extractTextForAndroidLinkOut(
  configurations,
  service,
  flowCode,
) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="utf-8"?>\n';
  res += '<resources>\n';

  res += '    <!--  Menu  -->\n';
  res += `    <string name="wls_menu_option_${flowCode}">${decipheringString(bank_name,
    service.name)}</string>\n`;
  res += '\n';
  res += '</resources>\n';
  return res;
}

export function extractTextForAndroid(configurations) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="utf-8"?>\n';
  res += '<resources>\n';

  res += '    <!--  Auth credentials  -->\n';
  res += `    <string name="wls_auth_credentials_title">${decipheringString(
    bank_name,
    configurations.launch.auth.enter_credentials,
  )}</string>\n`;
  res += `    <string name="wls_auth_credentials_free_text_hint">${decipheringString(
    bank_name,
    configurations.launch.auth.username,
  )}</string>\n`;
  res += `    <string name="wls_auth_credentials_password_hint">${decipheringString(
    bank_name,
    configurations.launch.auth.password,
  )}</string>\n`;
  res += `    <string name="wls_auth_credentials_approve_label">${decipheringString(
    bank_name,
    configurations.launch.auth.approve,
  )}</string>\n`;
  res += `    <string name="wls_auth_credentials_change_id_label">${decipheringString(
    bank_name,
    configurations.launch.auth.change_id,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Auth pin code  -->\n';
  res += `    <string name="wls_auth_pin_code_title">${decipheringString(
    bank_name,
    configurations.launch.auth.enter_your_pin_code,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Auth Password  -->\n';
  res += `    <string name="wls_auth_password_title">${decipheringString(
    bank_name,
    configurations.launch.auth.enter_credentials,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Auth OTP  -->\n';
  res += `    <string name="wls_auth_otp_title">${decipheringString(
    bank_name,
    configurations.launch.auth.enter_the_code_you_just_received,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Auth Biometric  -->\n';
  res
    += '    <string name="wls_auth_biometric_title">Use your biometric\\ncredential to continue</string>\n';
  res
    += '    <string name="wls_auth_biometric_hint">Touch the fingerprint sensor</string>\n';
  res
    += '    <string name="wls_auth_biometric_error">Fingerprint not recognized.\\nTry again</string>\n';
  res += '\n';
  res += '    <!--  Empty view  -->\n';
  res += `    <string name="wls_empty_view_title">${decipheringString(
    bank_name,
    configurations.launch.empty_state.nothing_to_see_here,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Landscape error  -->\n';
  res += `    <string name="wls_landscape_error_title">${decipheringString(
    bank_name,
    configurations.launch.error_messages.error_message_landscape_not_supported,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Errors  -->\n';
  res += `    <string name="wls_connection_error_button_label">${decipheringString(
    bank_name,
    configurations.launch.error_messages.reload,
  )}</string>\n`;
  res += `    <string name="wls_general_error_button_label">${decipheringString(
    bank_name,
    configurations.launch.error_messages.try_again,
  )}</string>\n`;
  res += `    <string name="wls_transaction_error_button_label">${decipheringString(
    bank_name,
    configurations.launch.error_messages.try_again,
  )}</string>\n`;
  res += '\n';
  res += '</resources>\n';
  return res;
}

export function extractTextForAndroid_Onboarding(configurations) {
  const { bank_name } = configurations.general;
  let res = '<?xml version="1.0" encoding="utf-8"?>\n';
  res += '<resources>\n';
  res += `    <string name="go_onboarding_next_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.announcement.o_a_button_title,
  )}</string>\n`;
  res += `    <string name="go_onboarding_cancel_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.announcement.maybe_later,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  OnBoarding Intro  -->\n';
  res += `    <string name="go_onboarding_intro_title">${decipheringString(
    bank_name,
    configurations.onboarding.announcement.o_a_title,
  )}</string>\n`;
  res += `    <string name="go_onboarding_terms_privacy_label">${decipheringString(
    bank_name,
    configurations.onboarding.announcement.o_a_privacy_policy,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  OnBoarding Typing Experience  -->\n';
  res += `    <string name="go_onboarding_typing_experience_title">${decipheringString(
    bank_name,
    configurations.onboarding.promotion.promo_text_1,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  OnBoarding Main Services  -->\n';
  res += `    <string name="go_onboarding_main_services_title">${decipheringString(
    bank_name,
    configurations.onboarding.promotion.promo_text_2,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  OnBoarding Security  -->\n';
  res += `    <string name="go_onboarding_security_title">${decipheringString(
    bank_name,
    configurations.onboarding.promotion.promo_text_4,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  OnBoarding Media  -->\n';
  res += `    <string name="go_onboarding_media_title">${decipheringString(
    bank_name,
    configurations.onboarding.promotion.promo_text_3,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Activation Enable Ime  -->\n';
  res += `    <string name="go_activation_enable_ime_subtitle">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_step_1_of_2,
  )}</string>\n`;
  res += `    <string name="go_activation_enable_ime_title">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_enable_bank_keyboard_and,
  )}</string>\n`;
  res += `    <string name="go_activation_enable_ime_security_title">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_your_privacy_title,
  )}</string>\n`;
  res += `    <string name="go_activation_enable_ime_security_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_your_privacy,
  )}</string>\n`;
  res += `    <string name="go_activation_enable_ime_next_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_take_me_there,
  )}</string>\n`;
  res += `    <string name="go_activation_enable_ime_cancel_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.maybe_later,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Activation Select Ime  -->\n';
  res += `    <string name="go_activation_select_ime_subtitle">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_step_2_of_2,
  )}</string>\n`;
  res += `    <string name="go_activation_select_ime_title">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_switch_to_bank_keyboard_and,
  )}</string>\n`;
  res += `    <string name="go_activation_select_ime_next_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_lets_do_it,
  )}</string>\n`;
  res += `    <string name="go_activation_select_ime_cancel_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.maybe_later,
  )}</string>\n`;
  res += '\n';
  res += '    <!--  Activation Success  -->\n';
  res += `    <string name="go_activation_success_title">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.success,
  )}</string>\n`;
  res += `    <string name="go_activation_success_next_button_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_done,
  )}</string>\n`;
  res += `    <string name="go_activation_success_content_title">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_give_it_a_go,
  )}</string>\n`;
  res += `    <string name="go_activation_success_content_label">${decipheringString(
    bank_name,
    configurations.onboarding.instructions.o_i_tap_the_bank_icon,
  )}</string>\n`;
  res += '\n';
  res += '</resources>\n';
  return res;
}
